import React, { useRef } from "react";
import Slider from "react-slick";
import "./css/PopularLocation.css";

const locations = [
  { name: "Maasai Mara", image: require("../assets/image/6.jpg"), location: "Narok", rating: "5" },
  { name: "Nairobi National Park", image: require("../assets/image/8.jpg"), location: "Nairobi", rating: "5"},
  { name: "Giraffe Center", image: require("../assets/image/9.jpg"), location: "Nairobi", rating: "4" },
  { name: "Camp Ndunda Falls", image: require("../assets/image/4.jpg"), location: "Meru", rating: "5" },
  { name: "Diani Beach", image: require("../assets/image/5.jpg"), location: "Diani", rating: "5" }
];

export default function PopularLocations() {
  const sliderRef = useRef(null);
   const renderStars = (count) => {
    return "★".repeat(count) + "☆".repeat(5 - count);
  };
  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false, // manual only
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } }
    ]
  };

  return (
    <div className="popular-locations container">
      

      

      <Slider ref={sliderRef} {...settings}>
        {locations.map((loc, index) => (
          <div key={index} className="location-card">
            <div className="image-wrapper">
              <img src={loc.image} alt={loc.name} />
              <div className="overlay">
                <h3>{loc.name} , </h3>
                <h4>{loc.location}</h4>
                <div>
                    <p>{renderStars(loc.rating)}</p>
                </div>
                <a className="btn-bl">Book Now</a>
              </div>
            </div>
          </div>
        ))}
      </Slider>
      <div className="slider-controls">
        <button onClick={() => sliderRef.current.slickPrev()} className="nav-btn">← Prev</button>
        <button onClick={() => sliderRef.current.slickNext()} className="nav-btn">Next →</button>
      </div>
    </div>
  );
}
